import Grid from "@mui/material/Grid";
import ValidatorSelectField from "../FormFields/ValidatorSelectField";
import { emailDefault, isPhoneNumberDefault, requiredValidator } from "../../services/validationRules";
import MenuItem from "@mui/material/MenuItem";
import ValidatorTextField from "../FormFields/ValidatorTextField";
import ButtonLoading from "../Button/ButtonLoading";
import DialogModal from "../DialogModal/DialogModal";
import EmailChange from "../LoginForm/EmailChange";
import React from "react";
import { useForm } from "../../provider/Form/FormProvider";
import { myAccountBoxStyle } from "./myAccountBoxStyle";

type PersonalDataFormProps = {
  isEmailModalOpen: boolean;
  setIsEmailModalOpen: (isEmailModalOpen: boolean) => void;
  newEmailAddress: string;
  isLoading: boolean;
};

export default function PersonalDataForm({ isEmailModalOpen, setIsEmailModalOpen, isLoading, newEmailAddress }: PersonalDataFormProps) {
  const { handleSubmit } = useForm();
  return (
    <>
      <form onSubmit={handleSubmit}>
        <Grid
          container
          spacing={0}
          sx={{
            justifyContent: "center",
          }}
        >
          <Grid size={12}>
            <ValidatorSelectField
              label={"Anrede"}
              name={"gender"}
              validators={[requiredValidator("Bitte geben Sie die Anrede an")]}
              MenuProps={{ slotProps: { paper: { style: { maxHeight: 200 } } } }}
            >
              <MenuItem value={"female"}>Frau</MenuItem>
              <MenuItem value={"male"}>Herr</MenuItem>
              <MenuItem value={"diverse"}>Divers</MenuItem>
            </ValidatorSelectField>
          </Grid>
          <Grid size={12}>
            <ValidatorTextField name="givenName" label="Vorname" validators={[requiredValidator("Bitte geben Sie Ihren Vornamen an")]} />
          </Grid>
          <Grid size={12}>
            <ValidatorTextField name="familyName" label="Nachname" validators={[requiredValidator("Bitte geben Sie Ihren Nachnamen an")]} />
          </Grid>
          <Grid size={12}>
            <ValidatorTextField
              name="telephone"
              label="Ihre Telefonnummer"
              autoComplete="tel"
              validators={[requiredValidator("Bitte geben Sie Ihre Telefonnummer an"), ...isPhoneNumberDefault]}
            />
          </Grid>
          <Grid size={12}>
            <ValidatorTextField
              name="email"
              label="Ihre E-Mail-Adresse"
              validators={[requiredValidator("Bitte geben Sie Ihre E-Mail-Adresse an"), emailDefault]}
            />
          </Grid>
          <Grid sx={myAccountBoxStyle.buttonSpace} size={12}>
            <ButtonLoading type="submit" fullWidth variant={"contained"} color={"primary"} isLoading={isLoading}>
              Speichern
            </ButtonLoading>
          </Grid>
        </Grid>
      </form>
      <DialogModal open={isEmailModalOpen} onClose={() => setIsEmailModalOpen(false)} title={"E-Mail-Adresse ändern"} responsive={true}>
        <EmailChange newEmail={newEmailAddress} handleClose={() => setIsEmailModalOpen(false)} />
      </DialogModal>
    </>
  );
}
